import React from 'react';
import { Check } from '@phosphor-icons/react';

/**
 * Multi-select chip picker for spoken languages.
 *
 * Keeps language codes ISO-639-1 (en, es, ...) to match what the backend
 * stores and filters on. Default catalog covers the construction industry's
 * top US languages — easy to extend later.
 */

export const LANGUAGE_CATALOG = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇲🇽' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦' },
];

export default function LanguagesPicker({
  value = [],
  onChange,
  className = '',
  testidPrefix = 'lang',
}) {
  const selected = new Set((value || []).map((c) => c.toLowerCase()));

  const toggle = (code) => {
    const next = new Set(selected);
    if (next.has(code)) next.delete(code);
    else next.add(code);
    onChange && onChange(Array.from(next));
  };

  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid={`${testidPrefix}-picker`}>
      {LANGUAGE_CATALOG.map((l) => {
        const active = selected.has(l.code);
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => toggle(l.code)}
            className={`flex items-center gap-1.5 h-9 px-3 text-xs font-bold rounded-full border-2 transition-all ${
              active
                ? 'bg-[#2B4C6F] text-white border-black shadow-[2px_2px_0px_#000]'
                : 'bg-white text-neutral-700 border-neutral-300 hover:border-black'
            }`}
            data-testid={`${testidPrefix}-${l.code}`}
            aria-pressed={active}
          >
            <span aria-hidden>{l.flag}</span>
            {l.label}
            {active && <Check size={12} weight="bold" />}
          </button>
        );
      })}
    </div>
  );
}
